// src/contexts/PedidosContext.tsx
import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';
import { Pedido } from './types';

type PedidosContextType = {
  pedidos: Pedido[];
  setPedidos: React.Dispatch<React.SetStateAction<Pedido[]>>;
};

const PedidosContext = createContext<PedidosContextType | null>(null);

export function PedidosProvider({ children }: { children: ReactNode }) {
  const [pedidos, _setPedidos] = useState<Pedido[]>([]);

  // Wrap the real setter with a logger/tracer
  const setPedidos: typeof _setPedidos = (updater) => {
    //console.group('🔄 setPedidos called');
    //console.trace();
    //console.log('→ Updater argument:', updater);
    //console.groupEnd();
    return _setPedidos(updater);
  };

  // Only re-create this object when `pedidos` changes
  const value = useMemo(
    () => ({
      pedidos,
      setPedidos,
    }),
    [pedidos]
  );

  return <PedidosContext.Provider value={value}>{children}</PedidosContext.Provider>;
}

export function usePedidos() {
  const ctx = useContext(PedidosContext);
  if (!ctx) throw new Error('usePedidos must be used within a PedidosProvider');
  return ctx;
}
